module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAMAAAA0jaRDAAAAwFBMVEXoES3oEi3oFSzpFi3pFy3pGSzpHyzpIyvpJCvqICzqKyrqLinqLynqMinrMCnrMinrMynrNSjrNSnsOyjsQSjsQyfsRCjsTSXsUSXtQyftRSftSCftUSXtUiXuUSXuWyTuXSPvWyXvXSXvaCLvaCPwYyPwayPwbiLwbyHwbyLwdCHxayLxdCHxeSHxgCDxgSDxgiDyfCHygR/ygiDyhh/yiR/ziB/ziR/zix/zkR3zmh3zmh70lh70nB351Bb51hapAZO3AAAAmUlEQVQYGc3B5wJCUBgA0M9FRBGirLJl79V8/7fqBa7/zoFNQqwg8gyCVaQSVnGRyQhWkHo+uRdnTA0K8LikNft3b5YJD1iEWp+eN/X6OvYaATi0v9hdfI87e/YowKG8WQqabxNIi08DDqH1h2j4DZFQqwRg8Um5tz7Wrk04wKOMdHTO7pTrJKxAclY8qlAhYRVieFFgEWzRH401DqiIVqjlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/kg.png
// module id = 311
// module chunks = 0